import React from 'react';

function PublicView({ featuredEvent, events }) {
    return (
        <div className="container">
            <h1>Y FIGHT</h1>
            <div className="tagline">
                Telegram-first multi-event fight platform
            </div>

            {featuredEvent && (
                <div className="featured-event">
                    <h2>{featuredEvent.title}</h2>

                    <div className="event-meta">
                        <div>
                            <span>📅</span> {new Date(featuredEvent.startsAt).toLocaleDateString()}
                        </div>
                        <div>
                            <span>📍</span> {featuredEvent.venue?.name || 'Venue TBA'}
                        </div>
                        <div>
                            <span>🏠</span> {featuredEvent.venue?.address || 'Address TBA'}
                        </div>
                        <div>
                            <span>👥</span> {featuredEvent.registrationCount || 0} / {featuredEvent.capacity}
                        </div>
                    </div>

                    <button
                        className="cta-main"
                        onClick={() => {
                            // Try to open Telegram app directly
                            window.location.href = "tg://resolve?domain=y_fight_bot&startapp";

                            // Fallback after delay (in case Telegram is not installed)
                            setTimeout(() => {
                                window.open("https://t.me/y_fight_bot?startapp", "_blank");
                            }, 500);
                        }}
                    >
                        Open Y Fight in Telegram
                    </button>
                </div>
            )}

            {events.length > 1 && (
                <div className="event-list">
                    <h3>Other Upcoming Events</h3>
                    {events.slice(1).map((e) => (
                        <div key={e._id} className="event-card">
                            <div style={{ fontWeight: 'bold' }}>{e.title}</div>
                            <div className="dim">
                                {new Date(e.startsAt).toLocaleDateString()}
                            </div>
                            <div className="dim">
                                {e.venue?.name || 'Venue TBA'}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="action-row">
                <div className="qr-small">
                    <img src="/qr-link.jpeg" alt="Community Link" />
                </div>
                <div className="cta-text">
                    <p>Official Channel</p>
                    <a href="https://t.me/y_fight" className="btn-link">
                        Join Community
                    </a>
                </div>
            </div>

            <div className="footer">
                Powered by <a href="https://ensopeople.org">Enso People</a>
            </div>
        </div>
    );
}

export default PublicView;